import { faBadgeCheck, faBook, faBookSparkles, faBoxHeart, faBrowser, faDiploma, faFileCertificate, faFileCode, faFilmSimple, faGraduationCap, faHeadSideHeadphones, faKeynote, faMedal, faNewspaper, faPodcast, faRocket, faSuitcase } from '@fortawesome/pro-solid-svg-icons';
import tokens from '../../../foundation/tokens/js/tokens';
// Constants.
// -----------------------------------------------------------------------------
// Default values.
export const FLAG_DEFAULT_SIZE = 'm';
// Each of the different flags that can be rendered.
export const FLAG_TYPES = [
    'award',
    'certification',
    'course',
    'degree',
    'job-position',
    'launch',
    'milestone',
    'open-source',
    'other',
    'podcast',
    'publication',
    'reading',
    'self-training',
    'side-project',
    'talk',
    'video-bookmark',
    'video-highlight',
    'website'
];
// Mappings
export const FLAG_PADDING_SIZES = {
    m: {
        horizontal: 'm',
        vertical: 's'
    },
    s: {
        horizontal: 's',
        vertical: 'xs'
    }
};
export const FLAG_VARIANT_BACKGROUND_COLOR = {
    award: tokens.colorbrewer.qualitative.set1[7].value,
    certification: tokens.colorbrewer.qualitative.set3[1].value,
    course: tokens.colorbrewer.qualitative.set3[10].value,
    degree: tokens.colorbrewer.qualitative.set3[6].value,
    'job-position': tokens.colorbrewer.qualitative.set1[9].value,
    launch: tokens.colorbrewer.qualitative.dark2[3].value,
    milestone: tokens.colorbrewer.qualitative.set1[2].value,
    'open-source': tokens.colorbrewer.qualitative.set2[4].value,
    other: tokens.colorbrewer.qualitative.pastel1[5].value,
    podcast: tokens.colorbrewer.qualitative.pastel1[3].value,
    publication: tokens.colorbrewer.qualitative.set1[3].value,
    reading: tokens.colorbrewer.qualitative.pastel1[2].value,
    'self-training': tokens.colorbrewer.qualitative.set3[5].value,
    'side-project': tokens.colorbrewer.qualitative.set1[5].value,
    talk: tokens.colorbrewer.qualitative.set1[5].value,
    'video-bookmark': tokens.colorbrewer.qualitative.pastel1[4].value,
    'video-highlight': tokens.colorbrewer.qualitative.set1[4].value,
    website: tokens.colorbrewer.qualitative.pastel1[6].value
};
export const FLAG_VARIANT_COLOR = {
    award: tokens.colors.white[100].value,
    certification: tokens.colors.white[100].value,
    course: tokens.colors.white[100].value,
    degree: tokens.colors.white[100].value,
    'job-position': tokens.colors.white[100].value,
    launch: tokens.colors.white[100].value,
    milestone: tokens.colors.white[100].value,
    'open-source': tokens.colors.white[100].value,
    other: tokens.colors.midnight[800].value,
    podcast: tokens.colors.midnight[800].value,
    publication: tokens.colors.white[100].value,
    reading: tokens.colors.midnight[800].value,
    'self-training': tokens.colors.white[100].value,
    'side-project': tokens.colors.white[100].value,
    talk: tokens.colors.white[100].value,
    'video-bookmark': tokens.colors.midnight[800].value,
    'video-highlight': tokens.colors.white[100].value,
    website: tokens.colors.midnight[800].value
};
export const FLAG_VARIANT_ICON = {
    award: faMedal,
    certification: faFileCertificate,
    course: faDiploma,
    degree: faGraduationCap,
    'job-position': faSuitcase,
    launch: faRocket,
    milestone: faBadgeCheck,
    'open-source': faFileCode,
    other: faBoxHeart,
    podcast: faPodcast,
    publication: faNewspaper,
    reading: faBook,
    'self-training': faHeadSideHeadphones,
    'side-project': faBookSparkles,
    talk: faKeynote,
    'video-bookmark': faFilmSimple,
    'video-highlight': faFilmSimple,
    website: faBrowser
};
export const FLAG_VARIANT_LABEL = {
    award: 'award',
    certification: 'certification',
    course: 'course',
    degree: 'degree',
    'job-position': 'job position',
    launch: 'launch',
    milestone: 'milestone',
    'open-source': 'open source',
    other: 'other',
    podcast: 'podcast',
    publication: 'publication',
    reading: 'reading',
    'self-training': 'self training',
    'side-project': 'side project',
    talk: 'talk',
    'video-bookmark': 'video',
    'video-highlight': 'video',
    website: 'website'
};
//# sourceMappingURL=Flag.constants.js.map